<app-modal-shell [showFooter]="true"
  [dismissLabel]="'general.close' | translate"
  (dismiss)="dismiss()">
  <div modalTitle>
    <h2>{{ 'room.editArea' | translate }}</h2>
  </div>

  @if (formGroup) {
    <form class="area-edit-modal"
      [formGroup]="formGroup">
      <div class="area-edit-modal__field">
        <label class="area-edit-modal__label">{{ 'room.name' | translate }}</label>
        <input class="area-edit-modal__input"
          autocapitalize="on"
          formControlName="name" />
      </div>

      @if (formGroup.get('label')?.value) {
        <div class="area-edit-modal__field">
          <label class="area-edit-modal__label">{{ 'room.label' | translate }}</label>
          <input class="area-edit-modal__input"
            autocapitalize="on"
            formControlName="label" />
        </div>
      }

      <div class="area-edit-modal__field">
        <label class="area-edit-modal__label">{{ 'room.size' | translate }}</label>
        <div class="area-edit-modal__input-wrap">
          <input class="area-edit-modal__input"
            type="number"
            formControlName="size" />
          <span class="area-edit-modal__unit">m<sup>2</sup></span>
        </div>
      </div>

      <div class="area-edit-modal__field">
        <label class="area-edit-modal__label">{{ 'room.internal_doors' | translate }}</label>
        <input class="area-edit-modal__input"
          type="number"
          formControlName="internal_doors" />
      </div>

      <div class="area-edit-modal__field">
        <label class="area-edit-modal__label">{{ 'room.external_doors' | translate }}</label>
        <input class="area-edit-modal__input"
          type="number"
          formControlName="external_doors" />
      </div>

      <div class="area-edit-modal__field">
        <label class="area-edit-modal__label">{{ 'room.windows' | translate }}</label>
        <input class="area-edit-modal__input"
          type="number"
          formControlName="windows" />
      </div>

      <div class="area-edit-modal__field">
        <label class="area-edit-modal__label">{{ 'room.volume' | translate }}</label>
        <div class="area-edit-modal__input-wrap">
          <input class="area-edit-modal__input"
            type="number"
            formControlName="volume" />
          <span class="area-edit-modal__unit">m<sup>3</sup></span>
        </div>
      </div>

      <div class="area-edit-modal__field">
        <label class="area-edit-modal__label">{{ 'room.height' | translate }}</label>
        <div class="area-edit-modal__input-wrap">
          <input class="area-edit-modal__input"
            type="number"
            formControlName="height" />
          <span class="area-edit-modal__unit">m</span>
        </div>
      </div>
    </form>
  }

  <div modalFooter>
    <button class="area-edit-modal__button area-edit-modal__button--secondary"
      type="button"
      (click)="dismiss()">
      {{ 'general.cancel' | translate }}
    </button>
    <button class="area-edit-modal__button area-edit-modal__button--primary"
      type="button"
      [disabled]="$safeNavigationMigration(formGroup?.invalid)"
      (click)="save()">
      {{ 'general.save' | translate }}
    </button>
  </div>
</app-modal-shell>